import {
  AuditOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CommentOutlined,
  FieldTimeOutlined,
  FileTextOutlined,
  HomeOutlined,
  NotificationOutlined,
  QuestionCircleOutlined,
  RetweetOutlined,
  RiseOutlined,
  RollbackOutlined,
  SettingOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { Paths } from 'shared/enums/paths';
import { IndicatorKeys, Permissions } from './types';
import { MenuItem, MenuKeys, MenuKeysMap } from './types';

export const menuItems: MenuItem[] = [
  {
    icon: <AuditOutlined />,
    label: 'Справки',
    key: MenuKeys.references,
    path: Paths.references,
    permissions: [Permissions['hr.document.access']],
    indicator: IndicatorKeys.document,
  },
  {
    icon: <CommentOutlined />,
    label: 'Консультации',
    key: MenuKeys.consultations,
    path: Paths.consultations,
    permissions: [Permissions['hr.consultation.access']],
    indicator: IndicatorKeys.consultation,
  },
  {
    icon: <ClockCircleOutlined />,
    label: 'Отпуск',
    key: MenuKeys.vacation,
    path: Paths.vacation,
    permissions: [Permissions['hr.vacation-application.access']],
    indicator: IndicatorKeys.vacation,
  },

  {
    icon: <CheckOutlined />,
    label: 'Согласование отпусков',
    key: MenuKeys.vacationApplication,
    path: Paths.vacationApplication,
    moderators: ['isActing', 'isDeputy', 'isSupervisor'],
  },
  {
    icon: <FileTextOutlined />,
    label: 'Неявки подчиненных',
    key: MenuKeys.absenceSupervisor,
    path: Paths.absenceSupervisor,
    moderators: ['isActing', 'isDeputy', 'isSupervisor', 'isTimekeeper'],
  },
  {
    icon: <CalendarOutlined />,
    label: 'Планирование отпусков',
    key: MenuKeys.vacationScheduleSubordinates,
    path: Paths.vacationScheduleSubordinates,
    moderators: ['isActing', 'isDeputy', 'isSupervisor'],
  },
  {
    icon: <HomeOutlined />,
    label: 'Отгулы подчиненных',
    key: MenuKeys.dayoffSupervisor,
    path: Paths.dayoffSupervisor,
    moderators: ['isActing', 'isDeputy', 'isSupervisor'],
  },
  {
    icon: <HomeOutlined />,
    label: 'Отмена отгулов подчиненных',
    key: MenuKeys.dayoffCancelSupervisor,
    path: Paths.dayoffCancelSupervisor,
    moderators: ['isActing', 'isDeputy', 'isSupervisor'],
  },
  {
    icon: <CalendarOutlined />,
    label: 'График отпусков',
    key: MenuKeys.vacationSchedule,
    path: Paths.vacationSchedule,
    permissions: [Permissions['hr.vacation-schedule.access']],
    indicator: IndicatorKeys.vacationSchedule,
  },
  {
    icon: <HomeOutlined />,
    label: 'Отгулы',
    key: MenuKeys.dayoff,
    indicator: IndicatorKeys.timeOff,
    path: Paths.dayoff,
    permissions: [Permissions['hr.time-off.access']],
  },
  {
    icon: <RollbackOutlined />,
    label: 'Отмена отгулов',
    key: MenuKeys.cancelDayoff,
    indicator: IndicatorKeys.timeOffCanceled,
    path: Paths.cancelDayoff,
    permissions: [Permissions['hr.vacation-application.access']],
  },
  {
    icon: <FileTextOutlined />,
    label: 'Неявки',
    key: MenuKeys.absence,
    path: Paths.absence,
    permissions: [Permissions['hr.absence.access']],
    indicator: IndicatorKeys.absence,
  },

  {
    icon: <RiseOutlined />,
    label: 'РВД',
    key: MenuKeys.rvd,
    path: Paths.rvd,
    permissions: [Permissions['hr.additional-income.wow.access']],
  },
  {
    icon: <FieldTimeOutlined />,
    label: 'Сверхурочная работа',
    key: MenuKeys.overtime,
    path: Paths.overtime,
    permissions: [Permissions['hr.additional-income.overtime.access']],
  },
  {
    icon: <SwapOutlined />,
    label: 'Замещения',
    key: MenuKeys.substitutions,
    path: Paths.substitutions,
    //TODO: Поменять для substitutions,как появится на бэке
    permissions: [Permissions['hr.substitution.access']],
  },
  {
    icon: <SettingOutlined />,
    label: 'Управление',
    key: MenuKeys.controls,
    path: Paths.controls,
    permissions: [Permissions['hr.employee-management.get-employees']],
  },
  {
    icon: <RetweetOutlined />,
    label: 'Отчёты',
    key: MenuKeys.reports,
    path: Paths.reports,
    permissions: [Permissions['hr.report.access']],
  },
  {
    icon: <NotificationOutlined />,
    label: 'Новости',
    key: MenuKeys.news,
    path: Paths.news,
    moderators: ['isNews'],
  },
  {
    icon: <QuestionCircleOutlined />,
    label: 'Часто задаваемые вопросы',
    key: MenuKeys.faq,
    path: Paths.faq,
    moderators: ['isFaq'],
  },
  {
    icon: <CheckCircleOutlined />,
    label: 'Опросы',
    key: MenuKeys.polls,
    path: Paths.polls,
    moderators: ['isPoll'],
  },
];
export const menuKeysMap: MenuKeysMap = {
  [Paths.home]: { openKeys: [MenuKeys.home] },
  [Paths.references]: { openKeys: [MenuKeys.references] },
  [Paths.consultations]: { openKeys: [MenuKeys.consultations] },
  [Paths.rvd]: { openKeys: [MenuKeys.rvd] },
  [Paths.vacation]: { openKeys: [MenuKeys.vacation] },
  [Paths.vacationApplication]: { openKeys: [MenuKeys.vacationApplication] },
  [Paths.vacationSchedule]: { openKeys: [MenuKeys.vacationSchedule] },
  [Paths.reports]: { openKeys: [MenuKeys.reports] },
  [Paths.controls]: { openKeys: [MenuKeys.controls] },
  [Paths.absence]: { openKeys: [MenuKeys.absence] },
  [Paths.absenceSupervisor]: { openKeys: [MenuKeys.absenceSupervisor] },
  [Paths.substitutions]: { openKeys: [MenuKeys.substitutions] },
  [Paths.news]: { openKeys: [MenuKeys.news] },
  [Paths.faq]: { openKeys: [MenuKeys.faq] },
  [Paths.overtime]: { openKeys: [MenuKeys.overtime] },
  [Paths.polls]: { openKeys: [MenuKeys.polls] },
  [Paths.dayoff]: { openKeys: [MenuKeys.dayoff] },
  [Paths.cancelDayoff]: { openKeys: [MenuKeys.cancelDayoff] },
  [Paths.vacationScheduleSubordinates]: { openKeys: [MenuKeys.vacationScheduleSubordinates] },
  [Paths.dayoffSupervisor]: { openKeys: [MenuKeys.dayoffSupervisor] },
  [Paths.dayoffCancelSupervisor]: { openKeys: [MenuKeys.dayoffCancelSupervisor] },
};
